/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React, { useEffect, useState } from 'react';
import './ImageViewer.css'

// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
    Spinner
} from "reactstrap";
import secureLocalStorage from "react-secure-storage";

import { formatInitialsName } from "../../../../utils/views/pages/InitialsFormat.js"
import { getImage, postImage } from "../../../../network/ApiAxios";

const ImageViewer = (props) => {
    const user = JSON.parse(secureLocalStorage.getItem("user"));
    const initials = formatInitialsName(user.name);
    const app = props.app
    const setApp = props.setApp
    const formDisabled = props.formDisabled
    const [imageContent, setImageContent] = useState()
    const [isLoading, setisLoading] = useState(false)

    /**
     * Carrega a foto do usuário ao abrir a página de perfil
     * e atualiza o rendering sempre que há modificação de nova
     * imagem a carregar
     */
    useEffect(() => {
        loadImage()
    }, [imageContent, app]);

    const loadImage = async () => {
        if (app?.image) {
            const response = await getImage(app?.image);
            const { data } = response;
            setImageContent(data);
        }
    };

    /**
     * Atualiza o arquivo de imagem para realizar o upload no
     * servidor
     * 
     * @param {*} event 
     */
    const handleFileChange = (event) => {
        setisLoading(true)
        handleUpload(event.target.files[0])
    };

    /**
     * Envia o arquivo de imagem selecionado para o servidor, 
     * que por sua vez, envia para o S3 da AWS. Faz a atualização de dados
     * do Usuário para considerar a nova imagem associada a ele.
     * 
     * @param {*} selectedFile 
     * @returns 
     */
    const handleUpload = async (selectedFile) => {
        if (!selectedFile) {
            alert('Please select a file first!');
            return;
        }

        const reader = new FileReader();
        reader.onloadend = async () => {

            //Convertendo o arquivo de imagem para o tipo
            //esperado pelo servidor e criando
            //o JSON padrão da API no backend
            const base64Image = reader.result.split(',')[1]; // Get Base64 part                 
            let extension = selectedFile.type.split('/')[1] //Get file extension
            let params = {
                account: user.account,
                imageData: base64Image,
                fileName: selectedFile.name,
                fileType: extension,
                objectId: app._id
            }

            //Postando a imagem para o servidor de backend
            const response = await postImage(params);
            const { data } = response;

            if (data.success) {               
                app.image = data.imageID.toString()
                setApp(app)
                //console.log(data)
                //console.log(app)
                await loadImage()
                setisLoading(false)
            }
        };
        reader.readAsDataURL(selectedFile);
    };


    return (
        <Col className="order-xl-2 mb-5 mb-xl-0" xl="8">
            <Card className="card-profile shadow-sm">


                <Col className="order-lg-2 mt-3" lg="12">
                    <div className='card-profile-label'>
                        <label className="form-control-label">
                            Product Picture
                        </label>
                    </div>
                    {isLoading ? (
                        <div style={
                            {

                                textAlign: 'center',
                            }
                        }>
                            <Spinner size="sm" className="me-2 mx-1" />
                        </div>
                    ) :
                        (
                            <div className="avatar-180">

                                {imageContent ? (
                                    <img
                                        alt="..."
                                        className="avatar-180__img"
                                        src={imageContent}
                                    />
                                ) : (
                                    <div className="user-initials-circle">
                                        {initials}
                                    </div>
                                )}

                                <input
                                    type="file"
                                    accept=".jpg, .jpeg, .png, image/gif"
                                    onChange={handleFileChange}
                                    disabled={formDisabled}
                                    style={
                                        {

                                            width: '200px',
                                            height: '200px',
                                            opacity: 0, //1 para ver onde está
                                            position: 'absolute',
                                            zIndex: 10,
                                            cursor: 'pointer',
                                            borderStyle: 'solid',
                                            borderWidth: '1px',
                                        }
                                    } >
                                </input>

                            </div>
                        )}

                </Col>

            </Card>
        </Col>
    )

}

export default ImageViewer;